import type { App, Plugin } from 'vue';
import VlDataTableExtended from './vl-data-table-extended.vue';
import VlDataTableExtendedPager from './subcomponents/data-table-extended-pager/vl-data-table-extended-pager.vue';

export default {
  install(Vue: App) {
    Vue.component('VlDataTableExtended', VlDataTableExtended);
    Vue.component('VlDataTableExtendedPager', VlDataTableExtendedPager);
  },
} as Plugin;

export { VlDataTableExtended, VlDataTableExtendedPager };
